import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=04b4ffba&scoped=true&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4ffba",
  null
  
)

export default component.exports